import React from "react";
import styles from "./styles.module.scss";

import classNames from "classnames";

interface SeparatorProps {
  className?: string;
  separatorWrapper?: string;
}

const Separator: React.FC<SeparatorProps> = ({ className,separatorWrapper }) => {
  return (
    <div className={classNames(styles.flex1,separatorWrapper)}>
      <div className={classNames(styles.separator, className)}></div>
    </div>
  );
};

export default Separator;
